import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { SETTINGS_TOOLTIP_TYPES } from 'components/NodeHeaderSettings/constants';

import { getRemoveOrRestoreTooltipMessage } from '../../utils';

function useTooltipTitle(
  valueType,
  nodeType,
  action = SETTINGS_TOOLTIP_TYPES.DELETE,
) {
  return useMemo(() => {
    const { tooltip, tooltipValues } = getRemoveOrRestoreTooltipMessage(
      action,
      valueType,
      nodeType,
    );

    return <FormattedMessage {...tooltip} values={tooltipValues} />;
  }, [valueType, nodeType, action]);
}

export default useTooltipTitle;
